/* eslint-disable react/prop-types */
import React from 'react';
import {
  ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip,
} from 'recharts';

/**
 * Single-series total workout-records-per-day trend (034 US3), on the shared
 * au-panel design system (matches MonitorSessionTrendChart / HeartRateSessionTrendChart).
 * Coral line, text-labelled legend, point tooltip (exact date + count), graceful
 * single-day/empty handling. NOT type-split — the type breakdown lives in the
 * Top workout types panel.
 *
 * Props: { data } — [{ date:'YYYY-MM-DD', records:int }] ascending
 */
const shortDate = (d) => (d ? String(d).split('-').slice(1).reverse().join('/') : '');

const WorkoutTrendChart = ({ data = [] }) => {
  const enough = Array.isArray(data) && data.length >= 2;
  const single = Array.isArray(data) && data.length === 1;

  return (
    <div className="au-panel" data-testid="wk-trend">
      <div className="au-panel__head">
        <h4 className="au-panel__title">Workouts per day</h4>
        <span className="au-spacer" />
        <div className="au-legend">
          <span><i style={{ background: '#f26b45' }} />Workout records</span>
        </div>
      </div>

      {enough ? (
        <ResponsiveContainer width="100%" height={240}>
          <LineChart data={data} margin={{ top: 8, right: 12, left: 0, bottom: 4 }}>
            <CartesianGrid stroke="#eef2f1" vertical={false} />
            <XAxis dataKey="date" tickFormatter={shortDate} tick={{ fontSize: 11, fill: '#94a3b8' }} />
            <YAxis width={44} tick={{ fontSize: 11, fill: '#94a3b8' }} allowDecimals={false} />
            <Tooltip
              formatter={(value) => [Number(value).toLocaleString(), 'Workout records']}
              labelFormatter={(l) => `Date: ${String(l).split('-').reverse().join('/')}`}
            />
            <Line type="monotone" dataKey="records" name="Workout records" stroke="#f26b45" strokeWidth={2.5} dot={false} />
          </LineChart>
        </ResponsiveContainer>
      ) : (
        <div className="au-chart-empty" data-testid="wk-trend-empty">
          {single
            ? `Single day: ${shortDate(data[0].date)} — ${Number(data[0].records).toLocaleString()} workout record(s).`
            : 'Not enough data to plot a trend (need at least 2 days).'}
        </div>
      )}
    </div>
  );
};

export default WorkoutTrendChart;
